import { gql } from "@apollo/client";

export const CREATE_PAYROLL_TEMPLATE = gql`
  mutation CreatePayrollTemplate($input: createPayrollTemplateInput) {
    createPayrollTemplate(input: $input) {
      templateName
      templateId
      payrollComponents {
        componentId
        componentType
        componentName
        value
        visibility
        payFrequency
        mappedCategory
        parentCategory
        order
      }
    }
  }
`;

export const CREATE_PAYROLL_TEMPLATE_US = gql`
  mutation CreatePayrollTemplateUS($input: createPayrollTemplateUSInput) {
    createPayrollTemplateUS(input: $input)
  }
`;

export const GET_PAYROLL_TEMPLATE_BY_ID = gql`
  query GetPayrollTemplateById($templateId: Int) {
    getPayrollTemplateById(templateId: $templateId) {
      templateName
      templateId
      # salaryPeriod
      country
      state
      city
      payrollCycle
      cutoffDate
      payrollComponents {
        componentId
        componentType
        calculationMode
        componentName
        value
        visibility
        payFrequency
        mappedCategory
        parentCategory
        order
        formula
        inputType
      }
      payrollUSComponents {
        componentId
        templateId
        UScomponents
      }
      # compensationOtherCal {
      #   otherAllowanceCalculation
      # }
      # payrollCalculation {
      #   Id
      #   calculation
      #   formula
      #   templateId
      # }
    }
  }
`;

export const GET_ALL_PAYROLL_TEMPLATES = gql`
  query GetAllPayrollTemplates {
    getAllPayrollTemplates {
      templateName
      salaryPeriod
      templateId
      overtime
      perHour
      payrollComponents {
        componentType
        componentName
        value
        visibility
        payFrequency
        calculationMode
        templateId
        mappedCategory
        parentCategory
        order
        componentId
        formula
        inputType
      }

      payrollUSComponents {
        componentId
        templateId
        UScomponents
      }
      country
      state
      city
      payrollCycle
      cutoffDate
    }
  }
`;
export const GET_PAYROLL_TEMPLATES_NAMES = gql`
  query getAllPayrollTemplates {
    getAllPayrollTemplates {
      templateName
      templateId
      salaryPeriod
      country
      state
      city
    }
  }
`;

export const Update_OTHER_ALLOWANCE_CAL = gql`
  mutation UpdateOtherAllowanceCal($input: otherAllowanceCalInput) {
    updateOtherAllowanceCal(input: $input)
  }
`;

export const GET_PAYROLL_TEMPLATE_OTHER_CALL = gql`
  query GetPayrollTemplateOtherCal {
    getPayrollTemplateOtherCal {
      otherAllowanceCalculation
      templateId
    }
  }
`;

export const UPDATE_PAYROLL_TEMPLATE = gql`
  mutation UpdatePayrollTemplate($input: updatePayrollTemplateInput) {
    updatePayrollTemplate(input: $input)
  }
`;
export const UPDATE_PAYROLL_COMPONENT = gql`
  mutation UpdatePayrollComponent($input: updatePayrollComponentInput) {
    updatePayrollComponent(input: $input)
  }
`;

export const UPDATE_PAYROLL_COMPONENT_US = gql`
  mutation UpdatePayrollComponentUS($input: updatePayrollTemplateUSInput) {
    updatePayrollComponentUS(input: $input)
  }
`;

export const DELETE_PAYROLL_TEMPLATE = gql`
  mutation DeletePayrollTemplate($templateId: Int) {
    deletePayrollTemplate(templateId: $templateId)
  }
`;

export const DELETE_PAYROLL_COMPONENT = gql`
  mutation DeletePayrollComponent($componentId: Int) {
    deletePayrollComponent(componentId: $componentId)
  }
`;
